import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Shield, Info } from 'lucide-react';
import { useCart } from '../context/CartContext';

const Navbar = () => {
  const { getTotalItems } = useCart();
  const navigate = useNavigate();

  return (
    <nav className="sticky top-0 z-50 shadow-sm border-b border-gray-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14">
          <Link to="/" className="hover:opacity-90 transition-opacity" data-testid="home-link">
            <img src="/logo-new.png" alt="Krishna Machinery Stores" className="h-11 w-auto object-contain" loading="eager" fetchPriority="high" />
          </Link>
          
          <div className="flex items-center gap-1">
            <button
              onClick={() => navigate('/cart')}
              className="relative p-2.5 text-[#1A3626] hover:bg-[#1A3626]/10 rounded-lg transition-colors"
              data-testid="cart-button"
            >
              <ShoppingCart className="h-5 w-5" />
              {getTotalItems() > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-[#C05A3E] text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center" data-testid="cart-count">
                  {getTotalItems()}
                </span>
              )}
            </button>

            <Link to="/admin" className="p-2.5 text-[#1A3626]/60 hover:text-[#1A3626] hover:bg-[#1A3626]/10 rounded-lg transition-colors" data-testid="admin-link" title="Admin Panel">
              <Shield className="h-5 w-5" />
            </Link>

            <Link to="/about" className="p-2.5 text-[#1A3626] hover:bg-[#1A3626]/10 rounded-lg transition-colors" data-testid="about-link" title="About Us">
              <Info className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
